<template>
    <div id="login-change" class="basket-user d-lg-flex align-content-lg-center">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="basket-user__icon" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#user"></use>
                </svg>
                <span class="hidden-xs-down">Logout</span>
            </a>
            <div class="account-menu dropdown-menu small">
                <a class="dropdown-item" :href="$ceres.urls.myAccount">
                {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                <a class="dropdown-item" href="#" v-logout> {{ $translate("Ceres::Template.loginLogout") }}</a>
            </div>
        </div>
        <div v-if="!isLoggedIn" class="dropdown">
            <a href="#" class="basket-user__icon" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#user"></use>
                </svg>
                <div class="d-none d-xl-block">Login</div>
            </a>
            <div class="account-menu dropdown-menu small">
                <a class="dropdown-item"  data-testing="login-select" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal();unmarkInputFields()">
                    <span class="hidden-xs-down">{{ $translate("Ceres::Template.login") }}</span>
                </a>
                <a class="dropdown-item" data-testing="register-select" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'" @click="createRegisterModal();unmarkInputFields()" v-if="showRegistration">
                    <span class="hidden-xs-down">{{ $translate("Ceres::Template.loginRegister") }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import ValidationService from "ceres/app/services/ValidationService";
import { isDefined } from "ceres/app/helper/utils";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

	data()
	{
		return {
			isLogin: App.templateType === "login",
			isRegister: App.templateType === "register"
		};
	},

    methods: {
		unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
